import React from 'react';
import WorkingTimesExportDialog from "./WorkingTimesExportDialog";
import SwapPersonnelDialog from "./SwapPersonnelDialog";

export default ( props  => {
    return (
        <React.Fragment>
            {props.type && props.type === 'export' && (
                <WorkingTimesExportDialog {...props} />
            )}
            {props.type && props.type === 'swap' && (
                <SwapPersonnelDialog {...props} />
            )}
        </React.Fragment>
    );
});
